import {
  deleteAllPages,
  deleteModifiedPagesInfo,
  saveModifiedPage,
  saveMultiplePages,
} from '~/services/indexedDB';
import { getStore } from '~/store';

function getStateFromStore() {
  const store = getStore();
  if (!store) return null;
  const state = store.getState();
  return state;
}

// This function is cloned from saveMultiplePages function in TracsactionHandler.js file
// Because that file imports fabric.js and it's not needed for category and search page
export async function savePagesState() {
  const state = getStateFromStore();
  const currentFontByName = state.acCanvas.currentFontByName;
  const pages = state.acSidebarPages.pages;
  const modifiedPagesInfo = state.acSidebarPages.modifiedPagesInfo;
  console.log('DATA_LOGIN:', {
    currentFontByName,
    pages,
    modifiedPagesInfo,
  });
  try {
    await deleteAllPages();
    await deleteModifiedPagesInfo();
    await Promise.all([
      // ...pages
      //   .filter((page) => page.json)
      //   .map((page, idx) => {
      //     return savePage({
      //       id: page.id || idx + 1,
      //       json: page.fullJSON,
      //       thumbnail: page.exportedThumbnailBase64,
      //       fonts: Object.values(currentFontByName),
      //     });
      //   }),
      await saveMultiplePages(
        pages
          .filter((page) => page.json)
          .map((page, idx) => {
            return {
              id: page.id,
              pageIndex: idx + 1,
              pageID: page.id,
              // json: page.fullJSON,
              json: page.json,
              thumbnail: page.exportedThumbnailBase64,
              fonts: Object.values(currentFontByName),
            };
          }),
      ),
      ...Object.keys(modifiedPagesInfo).map((key, idx) => {
        if (key === 'minDeletedPageIndex')
          return saveModifiedPage({
            id: idx,
            minDeletedPageIndex: modifiedPagesInfo.modifiedPagesInfo,
          });
        const page = modifiedPagesInfo[key];
        return saveModifiedPage({
          id: idx,
          pageId: page.pageId,
          type: page.type,
          srcPageIndex: page.srcPageIndex,
        });
      }),
    ]);
  } catch (error) {
    console.error(error);
  }
}
